
            const data = {"name":"triangle_left","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M10 5.869v4.263a1 1 0 0 1-1.555.832L5.248 8.832a1 1 0 0 1 0-1.664l3.197-2.132A1 1 0 0 1 10 5.87Z\" _fill=\"#363945\"/>","originalColors":[{"type":"fill","color":"#363945"}],"stopColors":[]}}
        
                    module.exports = data
                    